import { FC, useEffect, useRef, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import RightSidebar from "./RightSidebar/RightSidebar";
// import { useRefreshTokenQuery } from "@/store/api/authApi";
// import { getToken } from "@/helpers/cookiesHelper";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import NotificationPanel from "../Notification/NotificationPanel";
import { useAppSelector } from "@/hooks/useAppSelector";
import NewPostModal from "../UI/modal/NewPostModal/NewPostModal";
import { setCreatePostModalState } from "@/store/slice/modalSlice";
import { useLocation } from "react-router-dom";
import WelcomePopup from "./WelcomePopup/WelcomePopup";
import PostHeader from "./Headers/PostHeader/PostHeader";
import SearchWethemrkt from "./Headers/SearchWethemrkt/SearchWethemrkt";
import SavedPostHeader from "./Headers/SavedPostHeader/SavedPostHeader";
import LeaderboardHeader from "./Headers/LeaderboardHeader/LeaderboardHeader";
import TradingStockHeader from "./Headers/TradingStockHeader/TradingStockHeader";
import TransactionsHeader from "./Headers/TransactionsHeader/TransactionsHeader";
import ContactHeader from "./Headers/ContactHeader/ContactHeader";
import SimpleHeader from "./Headers/SimpleHeader/SimpleHeader";
import ConversationsHeader from "./Headers/ConversationsHeader/ConversationsHeader";

const WELCOME_POPUP_SEEN_KEY = "welcomePopupSeen";

interface ILayoutProps {}

const Layout: FC<ILayoutProps> = ({}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const hideRight =
    location.pathname === "/watchlist" ||
    location.pathname === "/leaderboard" ||
    location.pathname === "/purchased" ||
    location.pathname === "/drafts" ||
    location.pathname === "/trending" ||
    location.pathname === "/faq" ||
    location.pathname === "/coming-soon" ||
    location.pathname === "/conversations" ||
    location.pathname.startsWith("/settings");

  const hideHeader =
    location.pathname.startsWith("/settings") ||
    location.pathname === "/drafts" ||
    location.pathname === "/watchlist" ||
    location.pathname === "/coming-soon" ||
    location.pathname === "/privacy-policy";

  // useRefreshTokenQuery(undefined, { skip: !getToken() });
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const { isOpen: notificationState } = useAppSelector((state) => state.notificationState);
  const { createPostModal } = useAppSelector((state) => state.modalState);
  const { user } = useAppSelector((state) => state.auth);

  const [showWelcomePopup, setShowWelcomePopup] = useState(false);
  const welcomePopupPathname = useRef(location.pathname);

  useEffect(() => {
    if (user) return;
    if (localStorage.getItem(WELCOME_POPUP_SEEN_KEY)) return;
    setShowWelcomePopup(true);
    localStorage.setItem(WELCOME_POPUP_SEEN_KEY, "1");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.pathname !== welcomePopupPathname.current) {
      setShowWelcomePopup(false);
    }
  }, [location.pathname]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const renderHeader = () => {
    if (location.pathname.startsWith("/post/")) return <PostHeader />;
    // if (location.pathname === "/" ||
    //   location.pathname.startsWith("/stock")  ||
    //   location.pathname.startsWith("/profile"))
    //   return <SearchWethemrkt />;
    if (location.pathname.startsWith("/saved-post")) return <SavedPostHeader />;
    if (location.pathname.startsWith("/leaderboard")) return <LeaderboardHeader />;
    if (location.pathname.startsWith("/trending")) return <TradingStockHeader />;
    if (location.pathname.startsWith("/purchased")) return <TransactionsHeader />;
    if (location.pathname.startsWith("/contact-us")) return <ContactHeader />;
    if (location.pathname === "/conversations") return <ConversationsHeader />;
    if (location.pathname === "/faq") return <SimpleHeader title="FAQ" borderBottom />;
    else return <SearchWethemrkt />;
  };
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        overflowX: "hidden",
        overflowY: "scroll",
        background: "#ffffffff",
        WebkitOverflowScrolling: "touch",
      }}
      ref={scrollRef}
    >
      <Box
        sx={{
          position: "relative",
          margin: "0 auto",
          maxWidth: "1264px",
          minHeight: "100vh",
          display: "grid",
          // gridTemplateColumns: hideRight ? "261px minmax(0, 1004px) 0px" : "261px 640px 364px",
          // gridTemplateRows: "54px 1fr",
          gridTemplateColumns: isMobile
            ? "100%"
            : hideRight
              ? "261px minmax(0, 1004px) 0px"
              : "261px 640px 374px",

          gridTemplateRows: isMobile ? "54px 1fr auto" : "54px 1fr",
        }}
      >
        {/* Sidebar */}
        {!isMobile && (
          <Box
            sx={{
              gridColumn: "1 / 2",
              gridRow: "1 / span 2",
              position: "sticky",
              top: 0,
              alignSelf: "start",
              height: "100vh",
              bgcolor: theme.palette.custom.mainWhite,
              overflow: "hidden",
            }}
          >
            <Sidebar />
          </Box>
        )}

        {/* Header */}
        {!hideHeader && (
          <Box
            sx={{
              gridColumn: isMobile ? "1 / 2" : "2 / span 2",
              gridRow: "1 / 2",
              position: "sticky",
              top: 0,
              height: "54px",
              zIndex: 20,
              bgcolor: theme.palette.custom.mainWhite,
              maxWidth: isMobile ? "100%" : hideRight ? "1004px" : "640px",
              width: "100%",
              justifySelf: "stretch",
            }}
          >
            <Header>{renderHeader()}</Header>
          </Box>
        )}
        {/* Main */}
        <Box
          sx={{
            gridColumn: isMobile ? "1 / -1" : "2 / 3",
            gridRow: isMobile ? "2 / 3" : hideHeader ? "1 / span 2" : "2 / 3",
            padding: isMobile ? "0 16px" : 0,
            bgcolor: "transparent",
            minHeight: 0,
          }}
        >
          <Outlet context={{ scrollRef }} />
        </Box>

        {/* RightSidebar */}
        {!isMobile && !hideRight && (
          <Box
            sx={{
              gridColumn: "3 / 4",
              gridRow: "1 / span 2",
              position: "sticky",
              top: 0,
              height: "100vh",
              // overflow: "hidden",
              overflowY: "auto",
              padding: "0px 0 0px 3px",
            }}
            className="hide-scrollbar"
          >
            <RightSidebar />
          </Box>
        )}

        {notificationState && (
          <Box
            sx={{
              position: "fixed",
              top: -30,
              right: isMobile ? "16px" : `calc((100vw - 1440px)/2)`,
              zIndex: 20,
              width: "392px",
            }}
          >
            <NotificationPanel />
          </Box>
        )}

        <NewPostModal
          open={createPostModal}
          handleClose={() => dispatch(setCreatePostModalState(false))}
        />

        {showWelcomePopup && (
          <>
            <Box
              onClick={() => setShowWelcomePopup(false)}
              sx={{
                position: "fixed",
                inset: 0,
                bgcolor: "rgba(0, 0, 0, 0.1)",
                zIndex: 20,
              }}
            />
            <Box
              sx={{
                position: "fixed",
                top: "54px",
                right: isMobile ? "16px" : `calc((100vw - 1440px)/2 + 88px)`,
                zIndex: 21,
                width: isMobile ? "calc(100vw - 32px)" : "392px",
                maxWidth: "392px",
              }}
            >
              <WelcomePopup onClose={() => setShowWelcomePopup(false)} />
            </Box>
          </>
        )}
      </Box>


    </Box>
  );
};

export default Layout;
